module.exports = __webpack_public_path__ + "img/ht.83223775.svg";